const BUSINESS_PRIORITIES_NAMESPACE = 'jbp-business-priorities'

export const BUSINESS_PRIORITIES_TRANSLATION_KEYS = {
  listHeader: {
    title: `${BUSINESS_PRIORITIES_NAMESPACE}--header--title`,
    titleWorldwide: `${BUSINESS_PRIORITIES_NAMESPACE}--header--title-worldwide`,
    subtitleWorldwide: `${BUSINESS_PRIORITIES_NAMESPACE}--header--subtitle-worldwide`,
    subtitleMarket: `${BUSINESS_PRIORITIES_NAMESPACE}--header--subtitle-market`,
    cloneFromPreviousYear: `${BUSINESS_PRIORITIES_NAMESPACE}--header--clone-from-previous-year`,
    marketOverrides: `${BUSINESS_PRIORITIES_NAMESPACE}--header--market-overrides`,
    addBusinessPriorityWorldwide: `${BUSINESS_PRIORITIES_NAMESPACE}--header--add-business-priority-worldwide`,
    addBusinessPriorityMarket: `${BUSINESS_PRIORITIES_NAMESPACE}--header--add-business-priority-market`,
    addMarketBp: `${BUSINESS_PRIORITIES_NAMESPACE}--header--add-market-bp`,
    export: `${BUSINESS_PRIORITIES_NAMESPACE}--header--export`,
  },
  banner: {
    notPublishedTitle: `${BUSINESS_PRIORITIES_NAMESPACE}--banner--not-published-title`,
    notPublishedMessage: `${BUSINESS_PRIORITIES_NAMESPACE}--banner--not-published-message`,
    publishAction: `${BUSINESS_PRIORITIES_NAMESPACE}--banner--publish-action`,
    changesSinceLastVisit: `${BUSINESS_PRIORITIES_NAMESPACE}--banner--changes-since-last-visit`,
  },
  table: {
    columnName: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-name`,
    columnMarkets: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-markets`,
    columnProgramOfferings: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-program-offerings`,
    columnKeyInitiatives: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-key-initiatives`,
    columnStatus: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-status`,
    columnStatusInMarket: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-status-in-market`,
    columnMarketOverrides: `${BUSINESS_PRIORITIES_NAMESPACE}--table--column-market-overrides`,
    statusActive: `${BUSINESS_PRIORITIES_NAMESPACE}--table--status-active`,
    statusNotActive: `${BUSINESS_PRIORITIES_NAMESPACE}--table--status-not-active`,
    actionEdit: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-edit`,
    actionDelete: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-delete`,
    actionSwitchOnForMarket: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-switch-on-for-market`,
    actionSwitchOffForMarket: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-switch-off-for-market`,
    actionActivate: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-activate`,
    actionDeactivate: `${BUSINESS_PRIORITIES_NAMESPACE}--table--action-deactivate`,
  },
  form: {
    createTitle: `${BUSINESS_PRIORITIES_NAMESPACE}--form--create-title`,
    editTitle: `${BUSINESS_PRIORITIES_NAMESPACE}--form--edit-title`,
    nameLabel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--name-label`,
    descriptionLabel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--description-label`,
    statusLabel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--status-label`,
    marketsLabel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--markets-label`,
    marketsHint: `${BUSINESS_PRIORITIES_NAMESPACE}--form--markets-hint`,
    marketsCurrentlySetTo: `${BUSINESS_PRIORITIES_NAMESPACE}--form--markets-currently-set-to`,
    marketsRequired: `${BUSINESS_PRIORITIES_NAMESPACE}--form--markets-required`,
    offeringsLabel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--offerings-label`,
    offeringsHint: `${BUSINESS_PRIORITIES_NAMESPACE}--form--offerings-hint`,
    offeringsRequired: `${BUSINESS_PRIORITIES_NAMESPACE}--form--offerings-required`,
    cancel: `${BUSINESS_PRIORITIES_NAMESPACE}--form--cancel`,
    save: `${BUSINESS_PRIORITIES_NAMESPACE}--form--save`,
    create: `${BUSINESS_PRIORITIES_NAMESPACE}--form--create`,
  },
  switchConfirmDialog: {
    title: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--title`,
    messageSwitchOn: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--message-switch-on`,
    messageSwitchOff: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--message-switch-off`,
    wwLeadWarning: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--ww-lead-warning`,
    confirm: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--confirm`,
    cancel: `${BUSINESS_PRIORITIES_NAMESPACE}--switch-confirm--cancel`,
  },
  activationConfirmDialog: {
    activationTitle: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--title`,
    deactivationTitle: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--title-deactivation`,
    messageActivate: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--message-activate`,
    messageDeactivate: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--message-deactivate`,
    confirm: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--confirm`,
    cancel: `${BUSINESS_PRIORITIES_NAMESPACE}--activation-confirm--cancel`,
  },
  deleteConfirmDialog: {
    title: `${BUSINESS_PRIORITIES_NAMESPACE}--delete-confirm--title`,
    message: `${BUSINESS_PRIORITIES_NAMESPACE}--delete-confirm--message`,
    confirm: `${BUSINESS_PRIORITIES_NAMESPACE}--delete-confirm--confirm`,
    cancel: `${BUSINESS_PRIORITIES_NAMESPACE}--delete-confirm--cancel`,
  },
}
